// Expansión de un ticket en las fichas de cliente (Portal Vendedor y Admin VL): sus líneas en
// tarjetas, con folio y total al pie. Las líneas de la categoría filtrada van resaltadas.
import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';
import { formatMXN } from '@/shared/lib/format/money';

/** Clases de la tarjeta de una línea; la resaltada es la de la categoría filtrada. */
export function ticketLineClass(highlighted: boolean): string {
    return cn('bg-card', highlighted && 'border-primary/60 bg-primary/5');
}

/** Lista de líneas del ticket con su folio y total al pie. */
export function TicketLines({
    folio,
    totalCents,
    children,
}: {
    folio: string | null;
    totalCents: number;
    children: ReactNode;
}) {
    return (
        <div className="pl-5">
            <ul
                aria-label={folio ? `Productos del ticket ${folio}` : 'Productos del ticket'}
                className="flex flex-col gap-1.5"
            >
                {children}
            </ul>
            <div className="mt-1.5 flex items-baseline justify-between gap-2 text-[10.5px] text-muted-foreground">
                <span>
                    {folio ? (
                        <>
                            Ticket <span className="font-mono">{folio}</span>
                        </>
                    ) : null}
                </span>
                <span>
                    Total{' '}
                    <span className="font-bold tabular-nums text-foreground">
                        {formatMXN(totalCents / 100)}
                    </span>
                </span>
            </div>
        </div>
    );
}
